<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default {
    name: 'app',
    created(){
      //加载一些公共的资源，如imgprefix
      saveLocal('language','ch')
      let imgprefix = loadLocal('imgprefix', false);
      if (imgprefix === false) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'room',
            a: 'GetGolbalParamters',
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('imgprefix', response.imgprefix);
          }
        }).catch((err) => {

        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  #app
    width: 100%
    height: 100%

</style>



// WEBPACK FOOTER //
// src/App.vue